export enum OrganizationStatuses {
  /**
     * Подтверждена
     */
   ACCEPTED = 'accepted',

   /**
    * Отклонена
    */
   CANCELED = 'canceled',

   /**
    * На акцептовании
    */
   IN_VERIFICATION = 'in_verification',
}

export const OrganizationStatusesTranslate = {
  [OrganizationStatuses.ACCEPTED]: 'Подтверждена',
  [OrganizationStatuses.CANCELED]: 'Отклонена',
  [OrganizationStatuses.IN_VERIFICATION]: 'На акцептовании',
};
